import React from "react";
import { MDBFooter, MDBContainer, MDBRow, MDBCol } from "mdb-react-ui-kit";
import { FaGitlab, FaFacebook, FaTwitter, FaInstagram, FaGithub } from "react-icons/fa";
import { IconContext } from "react-icons/lib";

import "./styles/footer.css";

const Footer = ({ theme }) => {
  return (
    <MDBFooter className="text-center text-lg-start text-muted footer">
      <section className="">
        <MDBContainer className="text-center text-md-start mt-5">
          <MDBRow className="mt-3 justify-content-center">
            <MDBCol md="2" className="mx-0 mb-2">
              {theme === "dark" ? (
                <img
                  width="100%"
                  src="https://static.igem.wiki/teams/4393/wiki/description/waterloo-igem-logos/waterlooigem-light.png"
                  alt="logo"
                />
              ) : (
                <img
                  width="100%"
                  src="https://static.igem.wiki/teams/4393/wiki/description/waterloo-igem-logos/waterlooigem-dark.png"
                  alt="logo"
                />
              )}
            </MDBCol>
            <MDBCol md="2" className="mx-0 mb-2">
              <h6 className="headers mb-4">Project</h6>
              <p>
                <a href="/waterloo/description" className="text-reset">
                  Description
                </a>
              </p>
              <p>
                <a href="/waterloo/engineering" className="text-reset">
                  Engineering
                </a>
              </p>
              <p>
                <a href="/waterloo/model" className="text-reset">
                  Model
                </a>
              </p>
              <p>
                <a href="/waterloo/implementation" className="text-reset">
                  Implementation
                </a>
              </p>
              <p>
                <a href="/waterloo/proof-of-concept" className="text-reset">
                  Proof of Concept
                </a>
              </p>
            </MDBCol>

            <MDBCol md="2" className="mx-0 mb-2">
              <h6 className="headers mb-4">Parts</h6>
              <p>
                <a href="/waterloo/parts" className="text-reset">
                  Parts
                </a>
              </p>
              <p>
                <a href="/waterloo/contribution" className="text-reset">
                  Contribution
                </a>
              </p>
            </MDBCol>

            <MDBCol md="2" className="mx-0 mb-2">
              <h6 className="headers mb-4">Human Practices</h6>
              <p>
                <a href="/waterloo/human-practices" className="text-reset">
                  Human Practices
                </a>
              </p>
              <p>
                <a href="/waterloo/communication" className="text-reset">
                  Communication
                </a>
              </p>
            </MDBCol>

            <MDBCol md="2" className="mx-0 mb-2">
              <h6 className="headers mb-4">Team</h6>
              <p>
                <a href="/waterloo/members" className="text-reset">
                  Members
                </a>
              </p>
              <p>
                <a href="/waterloo/attributions" className="text-reset">
                  Attributions
                </a>
              </p>
              <p>
                <a href="/waterloo/collaborations" className="text-reset">
                  Collaborations
                </a>
              </p>
            </MDBCol>

            <MDBCol md="2" className="mx-0 mb-2">
              <h6 className="headers mb-4">Social Media</h6>
              <IconContext.Provider
                value={{ color: "var(--logo)", size: "2em" }}
              >
                <MDBRow className="me-1 justify-content-start">
                  <MDBCol className="mx-0 pe-0">
                    <a href="https://www.facebook.com/WaterlooiGEM/">
                      <FaFacebook />
                    </a>
                  </MDBCol>
                  <MDBCol className="mx-0 px-0">
                    <a href="https://twitter.com/waterloo_igem?lang=en">
                      <FaTwitter />
                    </a>
                  </MDBCol>
                  <MDBCol className="mx-0 px-0">
                    <a href="https://www.instagram.com/waterloo.igem/?hl=en">
                      <FaInstagram />
                    </a>
                  </MDBCol>
                  <MDBCol className="mx-0 px-0">
                    <a href="https://gitlab.igem.org/2022/waterloo">
                      <FaGitlab />
                    </a>
                  </MDBCol>
                  <MDBCol className="mx-0 px-0">
                    <a href="https://github.com/igem-waterloo/uwaterloo-igem-2022/tree/main">
                      <FaGithub />
                    </a>
                  </MDBCol>
                </MDBRow>
              </IconContext.Provider>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </section>
    </MDBFooter>
  );
};

export default Footer;
